import { render } from "./SystemEmailFullKit.vue?vue&type=template&id=239d1514"
import script from "./SystemEmailFullKit.vue?vue&type=script&lang=js"
export * from "./SystemEmailFullKit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__